const Today = ({ time }) => {
  let today = time;

  let weekdays = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  let dayOfWeek = weekdays[today.getDay()];
  let dayOfMonth = today.getDate();

  const nth = function (d) {
    if (d > 3 && d < 21) return "th";
    switch (d % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const month = months[today.getMonth()];

  const year = today.getFullYear();

  return (
    <h1>
      {dayOfWeek}, {dayOfMonth}
      {nth(dayOfMonth)} of {month} {year}
    </h1>
  );
};

export default Today;
